<script setup>
import { ref } from 'vue';
import PageLayout from 'dashboard/components-next/layout/PageLayout.vue';
import PageHeader from 'dashboard/components-next/layout/PageHeader.vue';
import SummaryReports from './components/SummaryReports.vue';
import V4Button from 'dashboard/components-next/button/Button.vue';

const summarReportsRef = ref(null);

const onDownloadClick = () => {
  summarReportsRef.value.downloadReports();
};
</script>

<template>
  <PageLayout>
    <template #header>
      <PageHeader
        icon="i-lucide-user"
        accent="slate"
        :title="$t('AGENT_REPORTS.HEADER')"
        :subtitle="$t('AGENT_REPORTS.DESCRIPTION')"
      >
        <template #actions>
          <V4Button
            :label="$t('AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS')"
            icon="i-ph-download-simple"
            size="sm"
            @click="onDownloadClick"
          />
        </template>
      </PageHeader>
    </template>

    <SummaryReports
      ref="summarReportsRef"
      action-key="summaryReports/fetchAgentSummaryReports"
      getter-key="agents/getAgents"
      fetch-items-key="agents/get"
      summary-key="summaryReports/getAgentSummaryReports"
      type="agent"
    />
  </PageLayout>
</template>
